import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faBook } from '@fortawesome/free-solid-svg-icons';
import { faTwitter, faTelegramPlane } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';

const PastLaunches = () => {
  const performanceData = [
    { title: "Launch to ATH", value: "1580x" },
    { title: "Lowest to ATH", value: "4020x" },
    { title: "Initial MCap", value: "$113,000" },
    { title: "ATH MCap", value: "$180M" }
  ];

  return (
    <section className="past-launches-section" style={{ paddingTop: '5%' }}>
      <div className="container">
        <h1 style={{
          fontSize: '36px',
          fontWeight: '600',
          color: '#fff',
          textAlign: 'center',
          marginBottom: '32px',
          fontFamily: 'Poppins, sans-serif',
          letterSpacing: '-0.5px'
        }}>
          Past Launches
        </h1>

        <div className="past-launch-wrapper" style={{
          background: '#1a1b23',
          borderRadius: '20px',
          padding: '32px',
          color: '#fff',
          maxWidth: '800px',
          margin: '0 auto',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          fontFamily: 'Poppins, sans-serif'
        }}>
          {/* Header Section */}
          <div className="project-header" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '20px',
            marginBottom: '24px'
          }}>
            <div className="logo-container" style={{
              background: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '12px',
              padding: '12px',
              width: '60px',
              height: '60px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <img
                src="/img/solchatmini1.png"
                alt="Project Logo"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain'
                }}
              />
            </div>

            <div className="project-info">
              <h2 style={{
                fontSize: '28px',
                fontWeight: '600',
                marginBottom: '12px',
                color: '#fff',
                fontFamily: 'Poppins, sans-serif'
              }}>SolChat</h2>

              <div style={{
                display: 'flex',
                gap: '12px'
              }}>
                <Link to="https://www.solchat.io/">
                  <div className="icon-block" style={{
                    background: 'linear-gradient(135deg, #9c42f5 0%, #4cacf5 50%, #4af5cb 100%)',
                    padding: '8px',
                    borderRadius: '8px',
                    width: '32px',
                    height: '32px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <FontAwesomeIcon size="lg" icon={faGlobe} style={{ color: "#000" }} />
                  </div>
                </Link>
                <Link to="https://x.com/solchatcoin">
                  <div className="icon-block" style={{
                    background: 'linear-gradient(135deg, #9c42f5 0%, #4cacf5 50%, #4af5cb 100%)',
                    padding: '8px',
                    borderRadius: '8px',
                    width: '32px',
                    height: '32px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <FontAwesomeIcon size="lg" icon={faTwitter} style={{ color: "#000" }} />
                  </div>
                </Link>
                <Link to="https://t.me/SolChatCoin">
                  <div className="icon-block" style={{
                    background: 'linear-gradient(135deg, #9c42f5 0%, #4cacf5 50%, #4af5cb 100%)',
                    padding: '8px',
                    borderRadius: '8px',
                    width: '32px',
                    height: '32px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <FontAwesomeIcon size="lg" icon={faTelegramPlane} style={{ color: "#000" }} />
                  </div>
                </Link>
                <Link to="https://docs.solchat.io/">
                  <div className="icon-block" style={{
                    background: 'linear-gradient(135deg, #9c42f5 0%, #4cacf5 50%, #4af5cb 100%)',
                    padding: '8px',
                    borderRadius: '8px',
                    width: '32px',
                    height: '32px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <FontAwesomeIcon size="lg" icon={faBook} style={{ color: "#000" }} />
                  </div>
                </Link>
              </div>
            </div>
          </div>

          {/* Info Box */}
          <div className="info-box" style={{
            background: '#2c2d33',
            borderRadius: '12px',
            padding: '20px',
            marginBottom: '24px',
            fontSize: '15px',
            lineHeight: '1.7',
            color: '#fff',
            fontFamily: 'Poppins, sans-serif',
            fontWeight: '400'
          }}>
            Solchat experienced a 1580x increase from its launch to the all-time high (ATH) and a 4020x increase from its lowest dip to the ATH. The initial market capitalization was approximately $113,000, while the ATH reached around $180 million.
          </div>

          {/* Performance Metrics */}
          <div className="metrics-table" style={{
            background: '#2c2d33',
            borderRadius: '12px',
            padding: '20px'
          }}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: '16px'
            }}>
              {performanceData.map((item, index) => (
                <div
                  key={index}
                  style={{
                    background: '#1a1b23',
                    padding: '16px',
                    borderRadius: '8px',
                    textAlign: 'center'
                  }}
                >
                  <div style={{
                    color: 'rgba(255, 255, 255, 0.7)',
                    fontSize: '13px',
                    marginBottom: '4px',
                    fontWeight: '500',
                    textTransform: 'uppercase',
                    fontFamily: 'Poppins, sans-serif'
                  }}>
                    {item.title}
                  </div>
                  <div style={{
                    background: 'linear-gradient(135deg, #9c42f5 0%, #4cacf5 50%, #4af5cb 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    fontSize: '22px',
                    fontWeight: '600',
                    fontFamily: 'Poppins, sans-serif'
                  }}>
                    {item.value}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <style>
            {`
              @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');

              .icon-block {
                transition: transform 0.3s ease;
              }
              .icon-block:hover {
                transform: translateY(-2px);
              }
              .info-box:hover, .metrics-table:hover {
                box-shadow: 0 4px 20px rgba(156, 66, 245, 0.1);
              }
            `}
          </style>
        </div>
      </div>
    </section>
  );
};

export default PastLaunches;